import type AssistantViewController from '../AssistantView/AssistantViewController';
import { type AttachmentStatus } from '../AssistantView/AssistantViewController';
import Attachment from '../../../framework/models/Attachment';
import { randomId } from '@aha-app/mvc';

// Open a modal to choose files to upload.
function chooseFiles(controller: AssistantViewController) {
  const input = document.createElement('input');
  input.type = 'file';
  input.multiple = true;

  input.onchange = event => {
    const files = (event.target as HTMLInputElement).files;
    if (files) {
      uploadFiles(controller, files);
    }
  };

  input.click();
}

// Upload an array of files to the server based on choosing files in a modal or dropping.
function uploadFiles(controller: AssistantViewController, files: FileList) {
  for (const file of files) {
    const attachmentStatus: AttachmentStatus = {
      id: randomId(),
      loading: true,
    };
    controller.actionAddAttachmentStatus(attachmentStatus);
    uploadAttachmentFile(controller, attachmentStatus, file);
  }
}

async function uploadAttachmentFile(
  controller: AssistantViewController,
  attachmentStatus: AttachmentStatus,
  file: File
) {
  const response = await fetch(
    `/attachments?qqfile=${encodeURIComponent(file.name)}`,
    {
      method: 'POST',
      headers: {
        'X-CSRF-Token': window.csrfToken(),
        'Content-Type': 'application/octet-stream',
      },
      body: file,
    }
  );
  if (!response.ok) {
    console.warn('Failed to upload attachment');
    return null;
  }

  const result = (await response.json()) as {
    attachmentId: string;
    attachmentUrl: string;
  };
  controller.actionSetAttachmentStatus(
    attachmentStatus,
    new Attachment({
      id: result.attachmentId,
      fileName: file.name,
      downloadUrl: result.attachmentUrl,
      contentType: file.type,
      fileSize: file.size,
    })
  );
}

export { chooseFiles, uploadFiles };
